import React from "react";
import AdminMenu from "../layout/AdminMenu";
import { makeStyles } from "@mui/styles"; // Mise à jour ici

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme?.palette?.background.default,
    minHeight: "100vh",
    padding: 2,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
  },
}));

export default function MainApp() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AdminMenu />
      {/* Ton contenu principal ici */}
    </div>
  );
}
